import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { Tracker } from '@core/services/event-tracker.service';
import { IdleCallbackService } from '@core/services/idle-callback.service';
import { AnalyticsEventName } from '@core/utils/AnalyticsEvents';
import { LOCALSTORAGE } from './local-storage.service';
import { WINDOW } from './window.service';

@Injectable({
    providedIn: 'root',
})
export class PlausibleService implements Tracker {
    plausible: any;
    readonly flag = 'plausible_ignore';
    constructor(
        private environmentService: EnvironmentService,
        private idleCallbackService: IdleCallbackService,
        @Inject(WINDOW) private window: Window,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(LOCALSTORAGE) private localStorage: Storage,
        @Inject(DOCUMENT) private document: Document
    ) {
        if (isPlatformBrowser(this.platformId)) {
            // @ts-ignore
            this.plausible = this.window.plausible;
        }
    }

    trackEvent(
        name: AnalyticsEventName,
        props?: { [key: string]: string | number | boolean }
    ) {
        if (isPlatformBrowser(this.platformId) && this.plausible) {
            this.plausible(name, { props: props });
        }
    }

    disable() {
        this.localStorage.setItem(this.flag, 'true');
    }

    isActive() {
        return this.localStorage.getItem(this.flag) !== 'true';
    }

    setup() {
        if (
            this.environmentService.isBrowser() &&
            !this.document.getElementById('plausible-script')
        ) {
            const script = this.document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('id', 'plausible-script');
            script.setAttribute('defer', '');
            script.setAttribute('async', '');
            script.setAttribute(
                'data-domain',
                this.environmentService.hostName().replace(/https?:\/\//i, '')
            );
            script.setAttribute(
                'src',
                'https://plausible.followalice.com/js/script.js'
            );
            // @ts-ignore
            script.onload = () => (this.plausible = this.window.plausible);
            this.idleCallbackService
                .firstIdleCallback()
                .subscribe(() => this.document.head.appendChild(script));
        }
    }
}
